import {Component, EventEmitter, Host, Input, OnInit, Optional, Output, ViewChild} from '@angular/core';
import {Sensor} from 'shared';
import {SensorHistoryRequest} from '../sensor-history-request';
import {SensorHistoryComponent} from '../sensor-history/sensor-history.component';
import {SensorHistoryPopupComponent} from '../sensor-history-popup/sensor-history-popup.component';
import ArrayStore from 'devextreme/data/array_store';
import {DxChartComponent, DxDataGridComponent} from 'devextreme-angular';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-sensor-history-chart',
  templateUrl: './sensor-history-chart.component.html',
  styleUrls: ['./sensor-history-chart.component.scss']
})
export class SensorHistoryChartComponent implements OnInit {

  @Input()
  sensor: Sensor;

  @Input()
  request: SensorHistoryRequest;

  @Input()
  toolbar: ArrayStore;

  @ViewChild(DxChartComponent)
  chartComponent: DxChartComponent;

  @ViewChild(DxDataGridComponent)
  gridComponent: DxDataGridComponent;

  view: 'chart' | 'table' = 'chart';

  constructor() {
    this.valueAxisAddUnit = this.valueAxisAddUnit.bind(this);
  }

  ngOnInit(): void {
    this.toolbar.insert({
      id: 'view',
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'auto',
      options: {
        icon: 'bulletlist',
        hint: 'Afficher Tableau',
        text: 'Tableau',
        type: 'normal',
        onClick: (e: any) => {
          if (this.view === 'chart') {
            this.view = 'table';
            this.toolbar.push([{type: 'update', data: {options: {icon: 'chart', text: 'Graph', hint: 'Afficher Graph'}}, key: 'view'}]);
          } else {
            this.view = 'chart';
            this.toolbar.push([{
              type: 'update',
              data: {options: {icon: 'bulletlist', text: 'Tableau', hint: 'Afficher Tableau'}},
              key: 'view'
            }]);
          }
        }
      },
    });
    this.toolbar.insert({
      id: 'export',
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'auto',
      options: {
        icon: 'export',
        hint: 'Exporter',
        type: 'normal',
        onClick: (e: any) => {
          if (this.view === 'chart') {
            this.chartComponent.instance.exportTo('historique', 'png');
          } else {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Historique');
            exportDataGrid({
              component: this.gridComponent.instance,
              worksheet
            }).then(() => {
              workbook.xlsx.writeBuffer()
                .then((buffer: BlobPart) => {
                  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'historique.xlsx');
                });
            });
          }
        }
      },
    });
    this.toolbar.insert({
      id: 'reset',
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'auto',
      options: {
        icon: 'refresh',
        hint: 'Réinitialiser',
        type: 'normal',
        onClick: (e: any) => {
          if (this.view === 'chart') {
            this.chartComponent.instance.resetVisualRange();
          } else {
            this.gridComponent.instance.refresh();
          }
        }
      },
    });
  }

  valueAxisAddUnit(label) {
    return label.valueText + ' ' + (this.sensor.unit === null ? '' : this.sensor.unit);
  }

}
